import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxBottomSheetService } from 'ngx-bottom-sheet';

@Component({
  selector: 'app-create-tag-form',
  templateUrl: './create-tag-form.component.html',
  styleUrls: ['./create-tag-form.component.scss'],
  standalone: false,
})
export class CreateTagFormComponent {
  data:
    | {
        title: string;
        label: string;
        value?: string;
      }
    | undefined = undefined;
  inputForm: FormGroup;
  private readonly _bottomSheet = inject(NgxBottomSheetService);

  constructor() {
    const _bottomSheet = this._bottomSheet;

    this.inputForm = new FormGroup({
      input: new FormControl(null, [Validators.required, Validators.maxLength(100), Validators.minLength(3)]),
    });
    this.data = _bottomSheet.currentSheetData;
    if (this.data?.value) {
      this.inputForm.patchValue({ input: this.data?.value || null });
    }
  }

  closeDialog(value?: 'save') {
    if (value === 'save' && this.inputForm.valid) {
      this._bottomSheet.close(this.inputForm.value.input);
    } else {
      this._bottomSheet.close();
    }
  }

  // closeDialog(value?: string) {
  //   this..close(value);
  // }
}
